var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImagePlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 712,
    height: 400,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-135.3%",
    y: "-124.3%",
    width: "370.6%",
    height: "348.6%",
    filterUnits: "objectBoundingBox",
    id: "a"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 24,
    dy: 24,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 24,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0941176471 0 0 0 0 0.137254902 0 0 0 0 0.203921569 0 0 0 0.04 0",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "93.094%",
    y1: "50%",
    x2: "20.788%",
    y2: "62.551%",
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    stopOpacity: 0.724,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M35.28 68.83L.892 85.88V25.673l50-24.792v58.02a3.533 3.533 0 0 1-1.975 3.167l-13.635 6.761z",
    id: "c"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#55C3F5",
    width: 712,
    height: 400,
    rx: 2
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)",
    transform: "rotate(27 -28.267 680.472)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.226 50.406l50-25.213L52.822.787a3.543 3.543 0 0 0-3.196 0l-48.4 24.406 50 25.213z",
    fill: "url(#b)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#25B2F2",
    fillRule: "nonzero",
    xlinkHref: "#c",
    transform: "translate(49.962 24.65)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.713 110.24L2.567 86.366A3.54 3.54 0 0 1 .713 83.26V25.24l50 24.791v60.208z",
    fillOpacity: 0.28,
    fill: "#FFF",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.48,
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M523.18 197.042l3.665 52.415-112.762-41.042L410.417 156z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4346DE",
    d: "M286.082 270.042l-3.665 52.415 112.762-41.042L398.845 229z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagePlaceholder);
export default __webpack_public_path__ + "static/media/image-placeholder.9309c9843d68e8494271a6f9690a07ac.svg";
export { ForwardRef as ReactComponent };